import React, { useContext, useState } from "react";
import Modal from "./Modal";
import { PhotoBoothSession } from "@mijnfotohoek-types";
import { Input } from "components/forms/Input";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Button from "components/forms/Button";
import firebase from "../../firebase";
import { DashboardContext } from "contexts/DashboardContext";
const ModalPhotoBoothSessionRename = ({
  close,
  session,
}: {
  close: () => void;
  session: PhotoBoothSession;
}) => {
  const [loading, setLoading] = useState(false);
  const { sendToast } = useContext(DashboardContext);
  const handleCreate = async (newName: string) => {
    setLoading(true);
    await firebase
      .firestore()
      .collection("photo_booth_sessions")
      .doc(session.id)
      .update({
        title: newName,
      });
    sendToast("Naam succesvol bijgewerkt", "", "success", 3000);
    setLoading(false);
    close();
  };

  return (
    <Modal close={close} title="Naam wijzigen" width={600}>
      <Formik
        initialValues={{ name: session.title }}
        validationSchema={Yup.object({
          name: Yup.string()
            .min(1, "Vul een naam in")
            .max(100, "Naam mag maximaal 100 tekens bevatten")
            .required("Vereist"),
        })}
        onSubmit={(values) => handleCreate(values.name)}
      >
        <Form>
          <div className="flex flex-col gap-4 mt-8">
            <Input type="text" centered={true} name="name" />
            <div className="flex justify-between mt-8">
              <Button type="submit" className="self-end" loading={loading}>
                Bijwerken
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
    </Modal>
  );
};

export default ModalPhotoBoothSessionRename;
